"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const planning_types_1 = require("./planning.types");
const onClickMutation = (payload) => dispatch => {
    dispatch({ type: planning_types_1.adjustmentPlanningTypes.ON_MUTATION_CLICK, payload });
};
const onCloseError = () => dispatch => {
    dispatch({
        type: planning_types_1.adjustmentPlanningTypes.SET_ERROR,
        payload: {
            errorCode: 0,
            errorMessage: '',
            isError: false
        }
    });
};
exports.default = { onCloseError, onClickMutation };
